import { render, staticRenderFns } from "./module5.vue?vue&type=template&id=aa5fcbe4&scoped=true"
import script from "./module5.vue?vue&type=script&lang=js"
export * from "./module5.vue?vue&type=script&lang=js"
import style0 from "./module5.vue?vue&type=style&index=0&id=aa5fcbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5fcbe4",
  null
  
)

export default component.exports